import type { ReactNode } from "react";
import { Area, AreaChart, YAxis } from "recharts";
import { GlowCard } from "@/ui/components/glow-card";
import { ChartContainer } from "@/ui/components/chart";

export function StatCard({
  label,
  value,
  unit,
  detail,
  spark,
}: {
  label: string;
  value: string;
  unit?: string;
  detail?: ReactNode;
  spark?: ReactNode;
}) {
  return (
    <GlowCard className="flex min-w-0 flex-col">
      <div className="flex flex-col gap-1 px-5 pt-5">
        <span className="text-[13px] text-muted-foreground">{label}</span>
        <span className="flex items-baseline gap-1">
          <span className="text-[28px] leading-none font-medium tracking-tight tabular-nums">{value}</span>
          {unit ? <span className="text-sm text-muted-foreground">{unit}</span> : null}
        </span>
        <span className="min-h-4 truncate text-xs text-muted-foreground">{detail}</span>
      </div>
      <div className="mt-3 h-14">{spark}</div>
    </GlowCard>
  );
}

export function Sparkline({ data, id, color = "var(--chart-2)" }: { data: { t: number; v: number }[]; id: string; color?: string }) {
  if (data.length < 2) return null;
  return (
    <ChartContainer config={{ v: { color } }} className="aspect-auto h-14 w-full">
      <AreaChart data={data} margin={{ top: 4, right: 0, bottom: 0, left: 0 }}>
        <defs>
          <linearGradient id={id} x1="0" y1="0" x2="0" y2="1">
            <stop offset="0%" stopColor="var(--color-v)" stopOpacity={0.22} />
            <stop offset="100%" stopColor="var(--color-v)" stopOpacity={0} />
          </linearGradient>
        </defs>
        <YAxis hide domain={[0, "auto"]} />
        <Area isAnimationActive={false} dataKey="v" type="monotone" stroke="var(--color-v)" strokeWidth={1.5} fill={`url(#${id})`} />
      </AreaChart>
    </ChartContainer>
  );
}
